import React, { useEffect, useState } from 'react'
import Layout from '../Layouts/Layout'
import db from '../db.js'
import { Link, useLocation } from 'react-router-dom'
import WeAreHere from '../Components/WeAreHere.js'
import { Helmet } from 'react-helmet-async'

export default function Home () {

  const [activeSlide, setActiveSlide] = useState(0)
  const courses = db.courses
  const dragStartX = React.useRef(null)

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveSlide(prev => (prev + 1) % courses.length)
    }, 4000)
    return () => clearInterval(timer)
  }, [courses.length])

  const handleDragStart = (e) => {
    dragStartX.current = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX
  }

  const handleDragEnd = (e) => {
    if (dragStartX.current === null) return
    const endX = e.type === 'touchend' ? e.changedTouches[0].clientX : e.clientX
    const diff = dragStartX.current - endX
    dragStartX.current = null
    if (Math.abs(diff) < 40) return
    if (diff > 0) setActiveSlide(prev => (prev + 1) % courses.length)
    else setActiveSlide(prev => (prev - 1 + courses.length) % courses.length)
  }

  const location = useLocation()
  useEffect(() => {
    if (location.hash && document.querySelector(location.hash)) {
      let element = document.querySelector(location.hash)
      console.dir(element.offsetTop)
      window.scrollTo({
        top: element.offsetTop,
        left: 0,
        behavior: 'smooth'
      })
    }
  }, [location])

  return (
    <Layout>
      <Helmet>
        <title>Kodart Tətbiq və Təlim Mərkəzi</title>
        <meta name="description" content="Kodart — proqramlaşdırma təlimləri və proqram təminatı xidmətləri. Uşaqlar və yeniyetmələr üçün Scratch, Python, veb-proqramlaşdırma kursları." />
        <link rel="canonical" href="https://kodart.az/" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="az_AZ" />
        <meta property="og:url" content="https://kodart.az/" />
        <meta property="og:title" content="Kodart Tətbiq və Təlim Mərkəzi" />
        <meta property="og:description" content="Kodart — proqramlaşdırma təlimləri və proqram təminatı xidmətləri." />
        <meta property="og:image" content="https://kodart.az/android-chrome-512x512.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Kodart Tətbiq və Təlim Mərkəzi" />
        <meta name="twitter:description" content="Kodart — proqramlaşdırma təlimləri və proqram təminatı xidmətləri." />
        <meta name="twitter:image" content="https://kodart.az/android-chrome-512x512.png" />
      </Helmet>
      <main data-page='home'>
          <section className='slider'>
            <img className='background' src='/Images/Background/code.png' alt={"background matrix code"}/>
            <div className="left-content">
              <div
                className="course-slider"
                onMouseDown={handleDragStart}
                onMouseUp={handleDragEnd}
                onTouchStart={handleDragStart}
                onTouchEnd={handleDragEnd}
              >
                {courses.map((c, i) => (
                  <div key={c.title} className={`slide${i === activeSlide ? ' active' : ''}`}>
                    
                    <div className="slide-content">
                      <img className="slide-logo" src={c.image} alt={c.name} />
                      <span className="slide-step">{c.prefix}</span>
                      <h3 className="slide-title">{c.name}</h3>
                      <p className="slide-description">{c.description.slice(0, 130)}...</p>
                      <div className="slide-actions">
                        <Link to={`/təlim/${c.title}`} className="slide-btn slide-btn-more">Ətraflı</Link>
                        <a href={db.contacts.whatsappLink} className="slide-btn slide-btn-wa"><img src="/Images/Icons/Contact/wa1.png" alt="" aria-hidden="true" />Bizə yazın</a>
                      </div>
                    </div>
                  </div>
                ))}
                <div className="slider-dots">
                  {courses.map((_, i) => (
                    <button
                      key={i}
                      className={`dot${i === activeSlide ? ' active' : ''}`}
                      onClick={() => setActiveSlide(i)}
                      aria-label={`Slayd ${i + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </section>
          <section className='section-container training-section'>
            <div className='section-header'>
              <h2>Təlimlərimiz</h2>
              <div className='green-dot-line'></div>
            </div>
            <div className='row'>
              {db.courses.sort((a,b) => +a.id - +b.id).map(c => {
                return (
                  <div key={c.title} className='col-12 col-sm-6 col-xl-3'>
                    <div className='course-card'>
                      <img className='card-icon' src={c.image} alt={c.name}/>
                      <h2><span className="prefix">{c.prefix}:</span> {c.name}</h2>
                      <p className='course-description'>{c.description}</p>
                      <Link
                        to={`/təlim/${c.title}`}
                        className='more-info-button'
                      >
                        Ətraflı məlumat
                      </Link>
                    </div>
                  </div>
                )
              })}
            </div>
          </section>
<WeAreHere />
        </main>
      </Layout>
  )
}
